<template>
    <div id="app">
        <router-view />
        <!-- <msgbox></msgbox> -->
    </div>
</template>

<script>
// 消息提示
// import msgbox from "@/components/tips/tips.vue";
import { config } from "@/utils/api/index";
export default {
    name: "App",
    components: {
        // msgbox: msgbox
    },
    mounted() {
        config().then(res => {});
        //     let a = res.data[0].long_text.split(",");
        //     // console.log(res.data[0].long_text);
        //     this.$store.commit("set_theme_arr", res.data[0].long_text);
        // });
        // 默认 1266
        // if (true) {
        //     let winWidth =
        //         document.documentElement.offsetWidth ||
        //         document.body.offsetWidth;
        //     winWidth = winWidth < 1400 ? 1500 : winWidth;
        //     // winWidth = winWidth > 1400 ? 1920 : winWidth;
        //     let oHtml = document.getElementsByTagName("html")[0];
        //     oHtml.style.fontSize = (100 * winWidth) / 1920 + "px";
        //     // 默认 	1400
        //     window.addEventListener("resize", function() {
        //         // 此处控制最小快递
        //         let winWidth =
        //             document.documentElement.offsetWidth ||
        //             document.body.offsetWidth;
        //         winWidth = winWidth < 1400 ? 1500 : winWidth;
        //         // winWidth = winWidth > 1400 ? 1500 : winWidth;
        //         let oHtml = document.getElementsByTagName("html")[0];
        //         oHtml.style.fontSize = (100 * winWidth) / 1920 + "px";
        //     });
        // }
    }
};
</script>

<style lang="scss">
// 全局颜色变量
@import "./utils/common/config.scss";
#app {
    min-width: 1300px;
    height: 100%;
}
* {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box !important;
    // font-family: "微软雅黑" !important;
    font-family: "Noto Sans SC";
    /* -moz-box-sizing:border-box;  */
    /* -webkit-box-sizing:border-box;  */
    font-size: 0;
    font-size: 0.16rem;
    font-size: 14px;
}
.theme {
    background: $base_color;
}
h1,
h2 {
    font-weight: normal;
}
ul {
    list-style-type: none;
    padding: 0;
}
/* li {
    display: inline-block;
    margin: 0 0;
} */
a {
    color: #000;
    /* list-style: none; */
    text-decoration: none;
}
input {
    outline: none;
}
/*去除样式 */
input[type="number"] {
    -moz-appearance: textfield;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
/* 禁止复制 */
.ns {
    /* onselectstart="return false;" */
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -khtml-user-select: none;
    user-select: none;
}
/* 按钮 */
.bt:hover {
    opacity: 0.9;
    cursor: pointer;
}
.ct {
    text-align: center;
}
::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.1);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(0, 0, 0, 0.5);
    /* background-color: #941100  */
}
// 图片预览的按钮大小
.root_top .el-image-viewer__close ::before {
    font-size: 30px !important;
    color: #fff !important;
}
// 富文本框的问题
.tox-tinymce-aux {
    z-index: 9999 !important;
}
// 网格线歪了的问题
.el-table th.gutter{
	display: table-cell!important; 
}
</style>



// WEBPACK FOOTER //
// src/App.vue